import { ActionTypeWithNumberId, TableColumn } from '../../../../../Component/Model/Table/Table';
import { Deviation } from '../../../../../Component/Model/Dto/EmploymentEquity/Plan/Deviation';
import { DefaultCell } from '../../../../../Component/Common/Components/DataTable/DefaultCell';
import { ActionsCell } from '../../../../../Component/Common/Components/DataTable/ActionsCell';
import { ActionsCellWithBadge } from '../../../../../Component/Common/Components/DataTable/ActionsCellWithBadge';
import { DataTableHtmlFormatter } from '../../../../../Component/Model/helpers';

interface DeviationRow {
	Id: number;
	JustifiableReason: string;
	Comments: string;
	SupportingDocuments: any[];
	Actions: ActionTypeWithNumberId[];
}

interface DeviationsTable {
	columns: Array<TableColumn>;
	rows: Array<DeviationRow>;
}

export function DeviationsTableMapper(
	dataObject: Deviation.SearchResultDto[],
	handleEdit: (id: number) => void,
	handleDelete: (id: number) => void,
	handleAttachedSD: (id: number) => void
): DeviationsTable {
	const columns = [
		{
			Header: 'Justifiable Reason',
			accessor: 'JustifiableReason',
			Cell: ({ value }: any) => <DefaultCell value={value} tooltip={true} maxWidth={'300px'}/>,
			disableSortBy: true
		},
		{
			Header: 'Comments',
			accessor: 'Comments',
			Cell: ({ value }: any) => <DefaultCell value={value} tooltip={true} maxWidth={'350px'}/>,
			disableSortBy: true
		},
		{
			Header: 'Supporting Documents',
			accessor: 'SupportingDocuments',
			Cell: ({ value }: any) => <ActionsCellWithBadge actions={value} key={value}/>,
			disableSortBy: true,
		},
		{ Header: 'Actions', accessor: 'Actions', Cell: ({ value }: any) => <ActionsCell actions={value} />, disableSortBy: true }
	];

	if (dataObject !== undefined && dataObject.length > 0) {
		const rows = dataObject.map((item: Deviation.SearchResultDto) => ({
			Id: item.id,
			JustifiableReason: item.justifiableReason,
			Comments: DataTableHtmlFormatter(item.comment, ' '),
			SupportingDocuments: [
				{
					label: `${item.documentCount} Supporting Document(s)`,
					action: handleAttachedSD,
					key: item.id,
					icon: { color: 'info', name: 'attach_file' },
					badgeCount: item.documentCount
				}
			],
			Actions: [
				{ label: 'View/Edit', action: handleEdit, key: item.id, icon: { color: 'info', name: 'edit' } },
				{ label: 'Delete', action: handleDelete, key: item.id, icon: { color: 'error', name: 'delete' } }
			]
		}));

		return { columns: columns, rows: rows };
	} else {
		return { columns: columns, rows: [] };
	}
}
